// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import less from 'less'
// import Vant from 'vant';
// import 'vant/lib/index.css';
import 'swiper/css/swiper.min.css';
import axios from '../node_modules/axios'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
// import 'lib-flexible/flexible.js'
import App from './App'
import router from './router'  
// import { DatetimePicker } from 'vant';

// Vue.use(DatetimePicker);
// 根据本地localStorage存储的当前语言类型，切换不同语言
// import zhCN from 'vant/es/locale/lang/zh-CN'
// import enUS from 'vant/es/locale/lang/en-US'
// let lang = localStorage.getItem('lang') || 'zh_CN'
// if (lang === 'en') {
//   Locale.use('en-US', enUS)
// } else {
//   Locale.use('zh-CN', zhCN)
// }

// import Router from 'vue-router'
// const routerPush = Router.prototype.push
//   Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }
    // 提示信息
    Vue.prototype.msgSuccess = function(msg,) {
      this.$message({ showClose: true, message: msg, type: "success"});
  }
  Vue.prototype.msgError = function(msg) {
      this.$message({ showClose: true, message: msg, type: "error" });
  }
  Vue.prototype.msgInfo = function(msg) {
      this.$message.info(msg);
  }
// import BaiduMap from 'vue-baidu-map'
// Vue.use(Vant);
Vue.prototype.allurl ="http://runhill.com.au/"
// Vue.use( BaiduMap, { ak : 'MGgZ5b1Ikuef4jwuRGFWnXXPZFcoEx0d' } )
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(less)

Vue.prototype.$echarts = echarts
Vue.use(echarts)
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
 
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js